module.exports = __webpack_public_path__ + "img/them-4.4ba1cba2.png";